module.exports = __webpack_public_path__ + "img/yacht-3.96ff2f78.jpg";